import zod from 'zod';
import { MANDATORY_FIELD } from '../../../config/zodConfig';
import { IntegrationFormSchema } from '../schemas';

export const TotvsIntegrationFormSchema = zod
  .object({
    username: zod
      .string({ required_error: MANDATORY_FIELD })
      .min(1, MANDATORY_FIELD),
    password: zod
      .string({ required_error: MANDATORY_FIELD })
      .min(1, MANDATORY_FIELD),
    domain: zod
      .string({ required_error: MANDATORY_FIELD })
      .min(1, MANDATORY_FIELD),
  })
  .merge(IntegrationFormSchema);
